import React from "react";
import { PlugZap, CheckCircle2, Clock } from "lucide-react";

export const ConnectionCard = ({ status }) => {
  if (!status) return null;
  const ok = status.configured;
  return (
    <div className={`mb-5 grid gap-3 rounded-2xl border p-4 text-sm md:grid-cols-2 ${ok ? "border-emerald-300 bg-emerald-50" : "border-amber-300 bg-amber-50"}`} data-testid="whatsapp-connection-card">
      <div className="flex items-start gap-3">
        {ok ? <CheckCircle2 className="mt-0.5 h-5 w-5 text-emerald-700" /> : <PlugZap className="mt-0.5 h-5 w-5 text-amber-700" />}
        <div>
          <div className="font-semibold text-emerald-950" data-testid="whatsapp-connection-status">
            WhatsApp Cloud API: {ok ? "credentials found on server" : "not connected"}
          </div>
          <p className="mt-0.5 text-xs text-emerald-900/70">
            {ok ? "Staff can submit queued reminders. A reminder is marked Sent or Delivered only after WhatsApp confirms it."
              : <>Nothing can be sent yet. Missing server settings: <span className="font-mono">{status.missing.join(", ")}</span>.</>}
          </p>
        </div>
      </div>
      <div className="flex items-start gap-3">
        <Clock className="mt-0.5 h-5 w-5 text-emerald-800/70" />
        <div>
          <div className="font-semibold text-emerald-950">Automatic scheduling: not set up</div>
          <p className="mt-0.5 text-xs text-emerald-900/70">Reminders are added to the queue and sent only when staff press the buttons below. The preferred sending time is saved for later use.</p>
        </div>
      </div>
    </div>
  );
};
